<template>
  <div class="page-container">
    <el-form
      :inline="true"
      class="demo-form-inline toolbar"
      style="padding-bottom: -10px"
    >
      <kt-button
        type="warning"
        icon="el-icon-back"
        label="返回"
        @click="goBack()"
      />
    </el-form>
    <div class="content">
      <table>
        <thead>
          <tr style="height: 60px; text-align: center">
            <td colspan="6" style="font-size: 18px; font-weight: 600">
              订单详情
            </td>
          </tr>
        </thead>
        <tbody>
          <tr style="height: 60px; text-align: center">
            <td style="font-size: 14px; font-weight: 600">老人姓名</td>
            <td colspan="2" width="35%">
              <span>{{ orderData.oldmanName }}</span>
            </td>
            <td style="font-size: 14px; font-weight: 600">老人地址</td>
            <td colspan="2" width="35%">
              <span>{{ orderData.serviceAddress }}</span>
            </td>
          </tr>
          <tr style="height: 60px; text-align: center">
            <td style="font-size: 14px; font-weight: 600">订单状态</td>
            <td colspan="2">
              <span>{{ orderData.statue }}</span>
            </td>
            <td style="font-size: 14px; font-weight: 600">服务时间</td>
            <td colspan="2">
              <span>{{ orderData.serviceTime }}</span>
            </td>
          </tr>
          <tr style="height: 60px; text-align: center">
            <td style="font-size: 14px; font-weight: 600">服务积分</td>
            <td colspan="2">
              <span>{{ orderData.integral }}积分</span>
            </td>
            <td style="font-size: 14px; font-weight: 600">服务人员</td>
            <td colspan="2">
              <span>{{ orderData.userNameGet }}</span>
            </td>
          </tr>
          <tr style="height: 60px; text-align: center">
            <td style="font-size: 14px; font-weight: 600">下单人</td>
            <td colspan="2">
              <span>{{ orderData.userNamePut }}</span>
            </td>
            <td style="font-size: 14px; font-weight: 600">联系电话</td>
            <td colspan="2">
              <span>{{ orderData.oldPhone }}</span>
            </td>
          </tr>
          <tr style="height: 60px; text-align: center">
            <td style="font-size: 14px; font-weight: 600">备注</td>
            <td colspan="4">
              <span>{{ orderData.remark }}</span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="6" style="font-size: 14px; font-weight: 600">
              <el-row>
                <el-col :span="1">
                  <el-steps
                    direction="vertical"
                    :space="55"
                    :active="orderStatus"
                    style="padding: 20px 30px; width: 100%"
                  >
                    <el-step
                      v-for="item in startOrderList"
                      :key="item.id"
                    ></el-step>

                    <!--请尝试可以动态修改stepService的height,暂未解决,零时使用v-if完成-->
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-if="orderContentTotal.length == 0"
                      class="stepService0"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 1"
                      class="stepService1"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 2"
                      class="stepService2"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 3"
                      class="stepService3"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 4"
                      class="stepService4"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 5"
                      class="stepService5"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 6"
                      class="stepService6"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 7"
                      class="stepService7"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 8"
                      class="stepService8"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 9"
                      class="stepService9"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 10"
                      class="stepService10"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 11"
                      class="stepService11"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 12"
                      class="stepService12"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 13"
                      class="stepService13"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 14"
                      class="stepService14"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else-if="orderContentTotal.length == 15"
                      class="stepService15"
                    ></el-step>
                    <el-step
                      v-for="item in contentOrderList"
                      :key="item.id"
                      v-else
                      class="stepServicebig"
                    ></el-step>
                    <el-step
                      v-for="item in endOrderList"
                      :key="item.id"
                    ></el-step>
                  </el-steps>
                </el-col>
                <el-col :span="23" style="padding: 7px 15px 0 30px">
                  <el-row
                    style="padding: 16px 0px 20px 0px"
                    v-for="item in startOrderList"
                    :key="item.id"
                  >
                    <el-col
                      >{{ item.userId }} {{ item.message }}:{{
                        item.time
                      }}</el-col
                    >
                  </el-row>
                  <el-row
                    style="padding: 17px 0px 12px 0px"
                    v-if="contentOrderList.length != 0"
                  >
                    <el-row>志愿者服务:</el-row>
                    <el-row style="margin-top: 20px" v-if="orderStatus > 3">
                      <el-col :span="1" class="col_Span">
                        <el-steps
                          direction="vertical"
                          :active="orderContentStatus"
                          style="margin: 3px 0px; width: 100%"
                          :space="53"
                        >
                          <el-step
                            v-for="item in orderContentTotal"
                            :key="item.id"
                          ></el-step>
                        </el-steps>
                      </el-col>
                      <el-col :span="23">
                        <el-row
                          style="margin: 5px 0"
                          v-for="item in orderContentTotal"
                          :key="item.id"
                        >
                          <el-row>{{ item.itemName }}</el-row>
                          <el-row
                            class="bigrow"
                            style="
                              font-size: small;
                              margin-top: 5px;
                              margin-bottom: 8px;
                              color: #244fbf;
                              cursor: pointer;
                            "
                          >
                            <el-button
                              type="text"
                              @click="showItemDetail(item)"
                              >{{ item.typeStr }}</el-button
                            >
                          </el-row>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-row>

                  <el-row
                    style="padding: 16px 0px 20px 0px"
                    v-for="item in endOrderList"
                    :key="item.id"
                  >
                    <el-col
                      >{{ item.userId }} {{ item.message }}:{{
                        item.time
                      }}</el-col
                    >
                  </el-row>
                </el-col>
              </el-row>
            </td>
          </tr>
        </tfoot>
      </table>

      <!--展示图片或者视频-->
      <el-dialog
        class="orderdialog"
        :visible.sync="imgDialog"
        :title="dialogtitle"
        width="500"
        center
      >
        <p v-if="showVideoFlag == 3" v-for="item in errorReportList">
          {{ item.content }}
        </p>
        <img
          :src="imgurl"
          v-if="showVideoFlag == 1"
          preview="1"
          style="
            width: 500px;
            height: 500px;
            vertical-align: middle;
            z-index: 99999;
          "
        />
        <!--视频展示-->
        <video
          v-if="showVideoFlag == 2"
          poster="@/assets/common/poster.png"
          ref="video"
          controls
          style="width: 500px; height: 500px"
        >
          <source :src="imgurl" type="video/mp4" />
          <!--<source src="" type="video/mp4">-->
          你的浏览器不支持video标签，请更新浏览器
        </video>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="imgDialog = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";

export default {
  components: { KtButton },
  data() {
    return {
      orderData: "",
      orderList: [],
      startOrderList: [],
      endOrderList: [],
      contentOrderList: [],
      orderStatus: 4,
      orderContentStatus: 2,
      id: "",
      imgDialog: false,
      imgurl: "",
      showVideoFlag: 0,
      dialogtitle: "",
      errorReportList: [],
      haveServiceDataFlag: false, //是否显示服务内容
      orderContentTotal: [],
    };
  },
  methods: {
    goBack() {
      console.log("返回上层");
      bus.$emit('close_current_tags');
    },
    getServiceContent(orderId) {
      //查询服务内容
      this.$postForm(
        "omc/orderServiceItem/queryListByOrderId/" + orderId,
        {}
      ).then((res) => {
        console.log(res);
        this.orderContentTotal = res.result;
        this.orderContentTotal.forEach((data) => {
          if (data.itemType == 0) {
            //图片
            data.typeStr = "查看图片";
          } else {
            //异常报告
            data.typeStr = "查看报告";
          }
        });
      });
    },
    showItemDetail(item) {
      console.log(item);
      //getItemContent //根据Id查询内容
      if (item.itemType == 0) {
        //pic,video
        //查找文件
        this.getPicUrl(item);
      } else {
        //异常报告
        //查询服务项
        this.getItemContext(item);
      }
    },
    getPicUrl(item) {
      this.$postForm("opc/file/queryAttachmentById/" + item.url, {}).then(
        (res) => {
          console.log(res);
          var url = "http://51cs8.com/" + res.result.path + res.result.name;
          console.log(url);
          this.dialogtitle = item.itemName;
          //判断是否是图片
          if (
            url.endsWith(".jpg") ||
            url.endsWith(".bmp") ||
            url.endsWith(".gif") ||
            url.endsWith(".jpe") ||
            url.endsWith(".jpeg") ||
            url.endsWith(".png") ||
            url.endsWith(".tig") ||
            url.endsWith(".tiff") ||
            url.endsWith(".ico")
          ) {
            this.imgurl = url;
            this.showVideoFlag = 1;
            this.imgDialog = true;
            this.dialogtitle = "图片";
          } else {
            this.imgurl = url;
            this.showVideoFlag = 2;
            this.imgDialog = true;
            this.dialogtitle = "视频";
          }
        }
      );
    },
    getItemContext(item) {
      this.$postForm(
        "omc/orderServiceItemContent/queryListByOrderServiceItemId/" + item.id,
        {}
      ).then((res) => {
        console.log(res);
        this.showVideoFlag = 3;
        this.dialogtitle = item.itemName;
        this.imgDialog = true;
        this.errorReportList = res.result;
        if (this.errorReportList.length == 0) {
          this.errorReportList.push({ content: "暂无报告内容" });
        }
      });
    },
    getOrderDetail() {
      this.$postForm("omc/order/showById/" + this.id, {}).then((res) => {
        console.log(res);
        this.orderData = res.result;
        this.orderList = res.result.lists.reverse();
        this.orderStatus = this.orderList.length;
        console.log(this.orderList);
        var qiandaoIndex = 0;
        this.haveServiceDataFlag = false;
        for (let i = 0; i < this.orderList.length; i++) {
          if (this.orderList[i].message == "签到") {
            qiandaoIndex = i;
          }
        }
        //是否签到
        //如果签到了,判断后面有不有
        //如果后面是签退,代表中间存在服务内容
        //如果后面没有,代表可能存在
        //如果后面不是,代表不存在,及放弃订单了,结束了
        if (qiandaoIndex != 0) {
          if (qiandaoIndex + 1 < this.orderList.length) {
            if (this.orderList[qiandaoIndex + 1].message == "签退") {
              this.haveServiceDataFlag = true;
              this.orderStatus = this.orderStatus + 1;
            }
          } else if (qiandaoIndex + 1 == this.orderList.length) {
            this.haveServiceDataFlag = true;
            this.orderStatus = this.orderStatus + 1;
          }
        }
        //存在服务的列表
        if (this.haveServiceDataFlag) {
          this.startOrderList = this.orderList.slice(0, qiandaoIndex + 1);
          this.contentOrderList.push({ id: "0" });
          this.endOrderList = this.orderList.slice(
            qiandaoIndex + 1,
            this.orderList.length
          );
          //获取服务内容;
          //更新orderContentTotal
          this.getServiceContent(this.orderData.id);
        } else {
          this.startOrderList = this.orderList;
          // this.contentOrderList.push({id:'0'});
        }

        switch (this.orderData.stat) {
          case 1:
            this.orderData.statue = "下单";
            break;
          case 2:
            this.orderData.statue = "待接单";
            break;
          case 3:
            this.orderData.statue = "已接单";
            break;
          case 4:
            this.orderData.statue = "取消接单";
            break;
          case 5:
            this.orderData.statue = "签到";
            break;
          case 6:
            this.orderData.statue = "签到超时";
            break;
          case 7:
            this.orderData.statue = "签退";
            break;
          case 8:
            this.orderData.statue = "签退超时";
            break;
          case 9:
            this.orderData.statue = "确认";
            break;
          case 10:
            this.orderData.statue = "确认超时";
            break;
          case 11:
            this.orderData.statue = "接单超时";
            break;
          case 12:
            this.orderData.statue = "取消下单";
            break;
        }
      });
    },
  },
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.getOrderDetail();
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  height: 500px;
  display: flex;
  flex-direction: column;
  background: #fff;
  .demo-form-inline {
    height: 60px;
  }
  .content {
    margin: 0px 0 30px 0;
    width: 100%;
    flex: 1;
    background: #fff;
    table {
      width: 100%;
      margin: 10px auto;
      border-collapse: collapse;
      border: 1px solid #cccccc;
    }
    td {
      border: 1px solid #cccccc;
    }
    ::deep .el-step {
      width: 50px;
    }
    ::deep .el-step__main {
      width: 0px;
      height: 0px;
    }
    ::deep .stepService0 .el-step__head {
      height: 77px;
    }
    ::deep .stepService1 .el-step__head {
      height: 131px;
    }
    ::deep .stepService2 .el-step__head {
      height: 186px;
    }
    ::deep .stepService3 .el-step__head {
      height: 241px;
    }
    ::deep .stepService4 .el-step__head {
      height: 296px;
    }
    ::deep .stepService5 .el-step__head {
      height: 350px;
    }
    ::deep .stepService6 .el-step__head {
      height: 404px;
    }
    ::deep .stepService7 .el-step__head {
      height: 459px;
    }
    ::deep .stepService8 .el-step__head {
      height: 510px;
    }
    ::deep .stepService9 .el-step__head {
      height: 565px;
    }
    ::deep .stepService10 .el-step__head {
      height: 620px;
    }
    ::deep .stepService11 .el-step__head {
      height: 674px;
    }
    ::deep .stepService12 .el-step__head {
      height: 729px;
    }
    ::deep .stepService13 .el-step__head {
      height: 783px;
    }
    ::deep .stepService14 .el-step__head {
      height: 838px;
    }
    ::deep .stepService15 .el-step__head {
      height: 892px;
    }
    ::deep .stepServicebig .el-step__head {
      height: 1000px;
    }
    ::deep .col_Span .el-steps {
      padding: 2px 0 !important;
    }
    ::deep .col_Span_steps .el-step__line {
      width: 0px !important;
    }
    ::deep .bigrow .el-button {
      padding: 0px;
    }
    // ::deep深度作用选择符
    ::deep .orderdialog .el-dialog__header {
      text-align: left;
      background: rgb(238, 231, 231);
      border-bottom: 2px solid rgb(211, 207, 207);
    }
    ::deep .orderdialog .el-dialog {
      margin-top: 60px !important;
      width: 45% !important;
    }
    ::deep .orderdialog .el-dialog .el-dialog__body {
      padding: 30px 0px;
      text-align: center;
    }
  }
}
</style>

